import { Routes, RouterModule } from '@angular/router';
import { NoPageFoundComponent } from './pages/shared/no-page-found/no-page-found.component';

const appRoutes: Routes = [
  { path: '**', component: NoPageFoundComponent },
];

export const APP_ROUTES = RouterModule.forRoot(appRoutes, { useHash: false, initialNavigation: 'enabled' });
